import React, {Component} from 'react';
import Loader from "react-loader-spinner";
import axios from "axios";
import {toast} from "react-toastify";
import ConsoleHelper from "../ConsoleHelper";


const options = [
    {
        label: "NA",
        value: "Select Country",
    },
    {
        label: "USA",
        value: "United States",
    },
    {
        label: "MEX",
        value: "Mexico",
    },
    {
        label: "EUR",
        value: "Europe",
    },
    {
        label: "CAN",
        value: "Canada",
    },
    {
        label: "IND",
        value: "India",
    },
    {
        label: "UK",
        value: "United Kingdom",
    },
];

const statusOptions = [
    {
        label: "NA",
        value: "Select Country",
    },
    {
        label: "IA",
        value: "InActive",
    },
    {
        label: "DA",
        value: "Disabled",
    },
    {
        label: "LO",
        value: "Locked",
    },
    {
        label: "XX",
        value: "Permanently Deleted",
    },
    {
        label: "PX",
        value: "Deleted",
    },
    {
        label: "AC",
        value: "Active",
    },
];

const typeOptions = [
    {
        value: "0",
        label: "Private",
    },
    {
        value: "1",
        label: "Public",
    },
    {
        value: "2",
        label: "ISO",
    },
];

export default class UserInfo extends Component {

    constructor(props){
        super(props);
        this.state = {
            isSubmit: false,
            paramUserID: null,
            paramFirstName: "",
            paramAddress: null,
            paramCity: null,
            paramLastName: null,
            paramRegion: null,
            paramTitle: null,
            paramCountry: null,
            paramUserCompanyName: null,
            paramPostalCode: null,
            paramPhone: null,
            paramStatus: null,
            paramFax: null,
            paramUserType: null,
            paramEMail: null,
            paramIsTerminalPrefix: null,
            paramIsAccountManager: null,
            paramIsNewTerminalID: null,
            paramIsCustomTerminalID: null,
            formFieldsEmpty: null,
            loggedInUser:null,
            paramParentUserID: null,
            paramCurrentUserID: null,
            userDetails: [],
            errors:{},
            formErrors: {
                paramUserID: "",
                paramFirstName: "",
                paramCity: "",
                paramLastName: "",
                paramAddress: "",
                paramRegion: "",
                paramPhone: "",
                paramTitle: "",
                paramCountry: "",
                paramUserCompanyName: "",
                paramPostalCode: "",
                paramStatus: "",
                paramFax: "",
                paramUserType: "",
                paramEMail: "",
                paramIsTerminalPrefix: "",
                paramIsAccountManager: "",
                paramIsNewTerminalID: "",
                paramIsCustomTerminalID: "",
                formFieldsEmpty: "",

            }
        };
    }

    componentDidMount() {

        axios.get(`getLoggedUserName?JSESSIONID=${sessionStorage.getItem('COOKIE')}`)
            .then(response => {

                this.setState({ loggedInUser: response.data })
                ConsoleHelper("=== LOG_1 === Inside componentDidMount %s with data ","User info",this.state.loggedInUser);

            }).finally(()=> {
        })
            .catch(error => {
                ConsoleHelper("GOT ERROR HERE for Get LoggedIn User",error);
            });
    }


    handleChange = event => {
        let formErrors = { ...this.state.formErrors };
        const { name, value } = event.target;

        if(this.state.paramUserID === null){
            // alert(this.state.loggedInUser)
        }
        switch (name) {
            case "paramFirstName":
                formErrors.paramFirstName =
                    value.length < 3 ? "Minimum 3 characters required" : "";
                break;
            default:
                break;
        }

        //this.setState({formErrors, [event.target.name]: event.target.value });
    }


    //Validation for All empty Fields
    formValidation = () =>{
        let {paramFirstName} = this.state;

        let isValid = true;
        let errors = {};
        if (!paramFirstName) {
            errors.paramFirstName = 'Please enter valid first Name';
        }else{
            isValid = true;
        }
        this.setState({errors});
        this.setState(this.resetStateUpdate(this.state,null));
        return isValid;
    }

    // Use the functional setState form
    resetStateUpdate =(state, props) =>{

        let userDet = this.props.data.data.userDetails.map((item, i) => (
            this.setState({
                paramUserID: item.userId,
                paramAddress: item.address ,
                paramFirstName: item.firstname,
                paramCity: item.city ,
                paramLastName: item.lastname,
                paramRegion: item.region ,
                paramTitle: item.title,
                paramCountry: item.country,
                paramUserCompanyName: item.usercompanyname ,
                paramPostalCode: item.postalcode,
                paramPhone: item.phone,
                paramStatus: item.status,
                paramFax: item.fax,
                paramUserType: item.usertype+'',
                paramEMail: item.email,
                paramIsTerminalPrefix: this.state.paramIsTerminalPrefix,
                paramIsAccountManager: this.state.paramIsAccountManager,
                paramIsNewTerminalID: this.state.paramIsNewTerminalID,
                paramIsCustomTerminalID: this.state.paramIsCustomTerminalID,
                paramCurrentUserID: this.state.loggedInUser,
                paramParentUserID: item.parentuserid})
        ));


        return {...state, userDet};
    }


    handleSubmit = event => {
        event.preventDefault();
        const user ={
            paramUserID: event.target.paramUserID.value,
            paramAddress: event.target.paramAddress.value,
            paramFirstName: event.target.paramFirstName.value,
            paramCity: event.target.paramCity.value,
            paramLastName: event.target.paramLastName.value,
            paramRegion: event.target.paramRegion.value,
            paramTitle: event.target.paramTitle.value,
            paramCountry: event.target.paramCountry.value,
            paramUserCompanyName: event.target.paramUserCompanyName.value,
            paramPostalCode: event.target.paramPostalCode.value,
            paramPhone: event.target.paramPhone.value,
            paramStatus: event.target.paramStatus.value,
            paramFax: event.target.paramFax.value,
            paramUserType: event.target.paramUserType.value,
            paramEMail: event.target.paramEMail.value,
            paramIsTerminalPrefix: event.target.paramIsTerminalPrefix.value,
            paramIsAccountManager: event.target.paramIsAccountManager.value,
            paramIsNewTerminalID: event.target.paramIsNewTerminalID.value,
            paramIsCustomTerminalID: event.target.paramIsCustomTerminalID.value,
            paramParentUserID: this.state.loggedInUser,
            paramCurrentUserID: this.state.loggedInUser,
        };

        this.setState(this.resetStateUpdate(this.state,null), () => {
        });

        const isValid = this.formValidation();
        if(isValid) {
            ConsoleHelper(user);

            axios.post(`updateUser`, user)
                .then(res => {
                    if (res.status === 200) {
                        alert('Data updated Successfully !!');
                        toast.success('Data updated Successfully !!', {position: toast.POSITION.TOP_CENTER, autoClose: 1000});
                    }else{
                        alert("Unable to update user !!");
                        toast.error("Unable to update user !!", {position: toast.POSITION.TOP_CENTER, autoClose: 1000})
                    }
                }).catch(error => {
                toast.error("Unable to update user !!", {position: toast.POSITION.TOP_CENTER, autoClose: 1000})
            });
        }else{
            ConsoleHelper(this.state);
            toast.error('Validation Failed!!', {position: toast.POSITION.TOP_CENTER,autoClose:1000})
        }

    }

    render() {
        const loader = {
            height: '700px',
            left: '40%',
            position: 'relative',
        };


        if (!this.props.data.data || this.props.data.data.loading) {
            return <Loader style={loader} type="ThreeDots" color="#e9953c" radius="5px" timeout={10000}/>;
        }
        const { formErrors } = this.state;
        const userDetailDiv = this.props.data.data.userDetails.map((item, i) => (


            <div className="tab-pane active" id="tb_userinfo" role="tabpanel">
                <form onSubmit={this.handleSubmit} autoComplete="off">
                    <div className="row">
                        <div className="col-md-6">
                            <h5 className="tbsub-title mt-3 mb-3">User Information</h5>
                            <div className="form-group">
                                <label className="control-label">User Id</label>
                                <input type="text" name="paramUserID" onChange={this.handleChange} readOnly={"true"}
                                       value={this.state.paramUserID ||item.userId } className={formErrors.paramUserID.length > 0 ? "form-control error" : "form-control"}
                                       autoComplete="off"
                                       placeholder="UserName"/>
                                {formErrors.paramUserID.length > 0 && (
                                    <span className="errorMessage">{formErrors.paramUserID}</span>
                                )}
                            </div>
                            <div className="form-group">
                                <label className="control-label">First Name</label>
                                <input type="text" name="paramFirstName"   onChange={e => this.handleChange.bind(this)}
                                       className={formErrors.paramFirstName.length > 0 ? "form-control error" : "form-control"}
                                       defaultValue={ item.firstname}
                                       key={item.firstname}
                                       placeholder="First Name"/>
                            </div>
                            {formErrors.paramFirstName.length > 0 && (
                                <span className="errorMessage">{formErrors.paramFirstName}</span>
                            )}
                            <div className="form-group">
                                <label className="control-label">Last Name</label>
                                <input type="text" name="paramLastName"  onChange={this.handleChange.bind(this)}
                                       defaultValue={ item.lastname}
                                       key={item.lastname}
                                       className={formErrors.paramLastName.length > 0 ? "form-control error" : "form-control"}
                                       placeholder="Last Name"/>
                            </div>
                            {formErrors.paramLastName.length > 0 && (
                                <span className="errorMessage">{formErrors.paramLastName}</span>
                            )}
                            <div className="form-group">
                                <label className="control-label">Title</label>
                                <input type="text" name="paramTitle" onChange={this.handleChange}
                                       /*value={this.state.paramTitle ||item.title }*/
                                       defaultValue={ item.title}
                                       key={item.title}
                                       className={formErrors.paramTitle.length > 0 ? "form-control error" : "form-control"}
                                       placeholder="Title"/>
                            </div>
                            <div className="form-group">
                                <label className="control-label">Company</label>
                                <input type="text" name="paramUserCompanyName" onChange={this.handleChange}
                                       defaultValue={ item.usercompanyname}
                                       key={item.usercompanyname}
                                       className={formErrors.paramUserCompanyName.length > 0 ? "form-control error" : "form-control"}
                                       placeholder="Company Name"/>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <h5 className="tbsub-title mt-3 mb-3">User Location</h5>
                            <div className="form-group">
                                <label className="control-label">Address</label>
                                <input type="text" name="paramAddress" onChange={this.handleChange}
                                       defaultValue={ item.address}
                                       key={item.address}
                                       className={formErrors.paramAddress.length > 0 ? "form-control error" : "form-control"}
                                       placeholder="Address"/>
                            </div>
                            <div className="form-group">
                                <label className="control-label">City</label>
                                <input type="text" name="paramCity" onChange={this.handleChange}
                                       defaultValue={ item.city}
                                       key={item.city}
                                       className={formErrors.paramCity.length > 0 ? "form-control error" : "form-control"}
                                       placeholder="Address"/>
                            </div>
                            <div className="form-group">
                                <label className="control-label">Region</label>
                                <input type="text" name="paramRegion" onChange={this.handleChange}
                                       defaultValue={ item.region}
                                       key={item.region}
                                       className={formErrors.paramRegion.length > 0 ? "form-control error" : "form-control"}
                                       placeholder="Region"/>
                            </div>
                            <div className="form-group">
                                <label className="control-label">Country</label>
                                {/*<select name="paramCountry" className="form-control select2">
                                    <option selected="selected">{ item.country}</option>
                                    <option value="NA">Select Country</option>
                                    <option value="USA">United States</option>
                                    <option value="MEX">Mexico</option>
                                    <option value="EUR">Europe</option>
                                    <option value="CAN">Canada</option>
                                    <option value="IND">India</option>
                                    <option value="UK">United Kingdom</option>
                                </select>*/}
                                <select name="paramCountry" className="form-control select2" defaultValue={ item.country}
                                        key={item.country}
                                         onChange={this.handleChange}>
                                    {options.map((option) => (
                                        <option value={option.label}>{option.value}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label className="control-label">Postal Code</label>
                                <input type="text" name="paramPostalCode" onChange={this.handleChange}
                                       defaultValue={ item.postalcode}
                                       key={item.postalcode}
                                       className={formErrors.paramPostalCode.length > 0 ? "form-control error" : "form-control"}
                                       placeholder="PostalCode"/>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <h5 className="tbsub-title mt-3 mb-3">Contact</h5>
                            <div className="form-group">
                                <label className="control-label">Phone</label>
                                <input type="text" name="paramPhone" onChange={this.handleChange}
                                       defaultValue={ item.phone}
                                       key={item.phone}
                                       className={formErrors.paramPhone.length > 0 ? "form-control error" : "form-control"}
                                       placeholder="Phone"/>
                            </div>
                            <div className="form-group">
                                <label className="control-label">Fax</label>
                                <input type="text" name="paramFax" onChange={this.handleChange}
                                       defaultValue={ item.fax}
                                       key={item.fax}
                                       className={formErrors.paramFax.length > 0 ? "form-control error" : "form-control"}
                                       placeholder="fax"/>
                            </div>
                            <div className="form-group">
                                <label className="control-label">Email</label>
                                <input type="text" name="paramEMail" onChange={this.handleChange}
                                       defaultValue={ item.email}
                                       key={item.email}
                                       className={formErrors.paramEMail.length > 0 ? "form-control error" : "form-control"}
                                       placeholder="Email"/>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <h5 className="tbsub-title mt-3 mb-3">Other</h5>
                            <div className="form-group">
                                <label className="control-label">Status</label>
                                {/*<select name="paramStatus" className="form-control select2" readOnly='true'>
                                    {(item.status === "AC") ? <option value="AC" selected='selected'>Active</option>:
                                        ((item.status === "IA") ? <option value="IA" selected='selected'>InActive</option>:
                                            <option value="-1" selected='selected'>Select Type</option>)}
                                </select>*/}
                                <select name="paramStatus" className="form-control select2"
                                        defaultValue={ item.status}
                                        key={item.status} onChange={this.handleChange}>
                                    {statusOptions.map((option) => (
                                        <option value={option.label}>{option.value}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label className="control-label">Type</label>
                                {/*<select name="paramUserType" className="form-control select2" readOnly='true'>
                                    {(item.usertype === 0) ? <option value="0" selected='selected'>Private</option>:
                                        ((item.usertype === 1) ? <option value="1" selected='selected'>Public</option>:
                                            <option value="-1" selected='selected'>Select Type</option>)}
                                </select>*/}
                                <select name="paramUserType" className="form-control select2"
                                         defaultValue={ item.usertype}
                                        key={item.usertype} onChange={this.handleChange}>
                                    {typeOptions.map((option) => (
                                        <option value={option.value}>{option.label}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-4 align-items-end">
                        <div className="col-md-6">
                            <div className="us_checkouter">
                                <div className="form-check mb-2">
                                    <input type="checkbox" name="paramIsAccountManager" className="form-check-input"
                                           id="chkbox1"/>
                                    <label className="form-check-label" htmlFor="chkbox1">Can
                                        this user access Account Manager?</label>
                                </div>
                                <div className="form-check mb-2">
                                    <input type="checkbox" name="paramIsNewTerminalID" className="form-check-input"
                                           id="chkbox2"/>
                                    <label className="form-check-label" name="" htmlFor="chkbox2">Can
                                        this user Create a New Terminal?</label>
                                </div>
                                <div className="form-check mb-2">
                                    <input type="checkbox" name="paramIsCustomTerminalID" className="form-check-input"
                                           id="chkbox3"/>
                                    <label className="form-check-label" htmlFor="chkbox3">Can
                                        this user Custom a Terminal ID?</label>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group mt-3 mb-2">
                                <label className="control-label">Prefix Terminal ID</label>
                                <input type="text" name="paramIsTerminalPrefix" autocomplete="off" onChange={this.handleChange}
                                       defaultValue={ this.state.paramIsTerminalPrefix}
                                       key={this.state.paramIsTerminalPrefix}
                                       className={formErrors.paramIsTerminalPrefix.length > 0 ? "form-control error" : "form-control"}
                                       placeholder="Terminal Prefix"/>
                            </div>
                        </div>
                    </div>
                    <div className="mt-4 sect_umupload">
                        <div className="row">
                            <div className="col-sm-8">
                                <div className="form-group">
                                    <label className="control-label">Upload Logo</label>
                                    <div className="input-group mb-3">
                                        <div className="custom-file mb-3">
                                            <input type="file" className="custom-file-input"
                                                   id="customFile" name="filename"/>
                                            <label className="custom-file-label"
                                                   htmlFor="customFile">Choose file</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-4 mt-4">
                                <div className="form-group">
                                    <button type="button"
                                            className="btn btn-secondary btn-outline-dark">Choose
                                        Default
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*<div className="row">
                        <div className="col-md-6">
                            <h5 className="tbsub-paramTitle mt-3 mb-3">Change Password</h5>
                            <div className="form-group">
                                <input type="password" name="paramSQLPassword" onChange={this.handleChange}
                                       className={formErrors.paramSQLPassword.length > 0 ? "form-control error" : "form-control"}
                                       placeholder="Password"/>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <h5 className="tbsub-paramTitle mt-3 mb-3">&nbsp;</h5>
                                <input type="password" name="paramTablePassword" onChange={this.handleChange}
                                       className={formErrors.paramTablePassword.length > 0 ? "form-control error" : "form-control"}
                                       placeholder="Confirm Password"/>
                            </div>
                        </div>
                    </div>*/}
                    <div className="row mt-5 justify-content-md-center">
                        <div className="col-md-4">
                            <button type="submit"
                                    className="btn btn-block btn-primary w-md">Update User
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        ));
        return userDetailDiv;
    }
}